import { Pagination } from "@/components/kit";
import { useQueryParams } from "@/hooks/general/useQueryParams";
import { Meta } from "@/@types/axios";
// import { TOrganization, TOrganizationParamsType } from "../../types";
// import OrganizationTable from "./OrganizationsTable";
import { useSearchParams } from "react-router-dom";
import { IUserResponse, TAdminParamsType } from "../types";
import MspAdminTable from "./MspAdminTable";

const MspAdminList = ({
  data,
  isFetching,
  meta,
}: {
  data: IUserResponse[];
  meta: Meta | undefined;
  isFetching: boolean;
}) => {
  const [searchParams] = useSearchParams();
  const stringPageNumber = searchParams.get("page");
  const stringLimit = searchParams.get("limit");
  const limit = stringLimit ? +stringLimit : 25;
  const page = stringPageNumber ? +stringPageNumber : 1;

  const { setParams, params, setParam } = useQueryParams<TAdminParamsType>({
    page: 1,
    limit: 25,
    orderDirection: "DESC",
  });

  function handleSetPageIndex(page: number) {
    setParam("page", page);
  }

  function onSelectLimit(limit: number) {
    setParams({
      ...params,
      page: 1,
      limit,
    });
  }

  return (
    <div className="flex-1 flex flex-col">
      <div className="flex-1 basis-0 overflow-y-auto">
        <MspAdminTable
          data={data}
          loading={isFetching}
          onViewDetails={() => {}}
        />
      </div>

      <div className="my-4 mx-4">
        <Pagination
          totalPages={meta?.totalPages ?? 0}
          totalItems={meta?.totalItems ?? 0}
          limit={limit}
          activePage={page}
          onSetActivePage={handleSetPageIndex}
          onSelectLimit={onSelectLimit}
        />
      </div>
    </div>
  );
};

export default MspAdminList;
